import axios from "axios";
import { baseUrl } from "../config/config";

export const isMessageSentByMe = async (user, latestMessageId) => {
  if(user && latestMessageId){
      try {
          const {data} = await axios.get(`${baseUrl}/message/oneMessage/${latestMessageId}`);
          if (data?.sender?.id !== user?.id && data?.isRead === false) {
            console.log(true);
            return true;
          }
          console.log(false);
          return false;
      } catch (error) {
          console.log(error);
      }
  }
}

export const isSenderIsMe = async (user, latestMessageId) => {
  if(user && latestMessageId){
      try {
          const {data} = await axios.get(`${baseUrl}/message/oneMessage/${latestMessageId}`);
          if (data?.sender?.id !== user?.id) {
            return false;
          }
          return true;
      } catch (error) {
          console.log(error);
      }
  }
}

export const short = (latestMessage) => {
  if(latestMessage){
    if(latestMessage.length > 10){
      return `${latestMessage.substring(0,36)}...`
    }
    else{
      return latestMessage;
    }
  }
}